<template>
  <div>
    <div class="mb-10 flex flex-col">
      <div
        class="mb-5 flex flex-col gap-5 font-roboto text-[18px] font-medium leading-[22px] text-new-card--title-black md:mb-2.5 md:ml-auto md:flex-row"
      >
        <NuxtLink class="link-item" to="/encyclopedia/about"
          >О проекте</NuxtLink
        >
        <NuxtLink class="link-item" to="/encyclopedia/catalog"
          >Каталог</NuxtLink
        >
        <NuxtLink class="link-item" to="/encyclopedia/dictionary"
          >Алфавитный справочник</NuxtLink
        >
      </div>
      <h1
        class="text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
      >
        <NuxtLink class="link-item" to="/encyclopedia"
          >Российская историческая энциклопедия</NuxtLink
        >
      </h1>
    </div>
    <NuxtPage />
  </div>
</template>

<script setup></script>

<style lang="scss">
.link-item.router-link-exact-active {
  @apply text-specialprojectsection;
}
</style>
